import { render, staticRenderFns } from "./GuiaHonorarios.vue?vue&type=template&id=f5bd8fe2&"
import script from "./GuiaHonorarios.vue?vue&type=script&lang=js&"
export * from "./GuiaHonorarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports